"use strict";
/**
 * array를 perChunk 길이의 subArray들이 담긴 배열로 변환
 * @param array - 나눌 배열
 * @param perChunk - subArray의 최대 length
 * @example chunkArray([1,2,3,4,5], 2)
 * -> returns [[1,2],[3,4],[5]]
 */
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(array, perChunk) {
    return array.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / perChunk);
        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = []; // start a new chunk
        }
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
exports.default = default_1;
